import { StreamChat } from "stream-chat";
/** Disconnect the shared Stream Chat singleton if a user is connected. */
export async function disconnectDoctorStreamChat() {
    const apiKey = process.env.NEXT_PUBLIC_GETSTREAM_API_KEY || "";
    if (!apiKey)
        return;
    const client = StreamChat.getInstance(apiKey);
    if (!client.userID)
        return;
    try {
        await client.disconnectUser();
    }
    catch (error) {
        console.warn("DoctorStreamChat: disconnectUser failed", error);
    }
}
